import MoveTo from 'moveto';

export default class MoveToController{

	static easings = {
		easeInQuad:  (t, b, c, d) => {
			t /= d;
			return c * t * t + b;
		},
		easeOutQuad: (t, b, c, d) => {
			t /= d;
			return -c * t* (t - 2) + b;
		},
		easeInOutQuad: (t, b, c, d) => {
			t /= d/2;
			if (t < 1) return c/2*t*t + b;
			t--;
			return -c/2 * (t*(t-2) - 1) + b;
		},
		linear: (t, b, c, d) => {
			return c*t/d + b;
		},
	};

	static moveTo = new MoveTo({
		tolerance: 0,
		duration: 750,
		easing: 'easeInOutQuad',
	}, MoveToController.easings);


	static move(target, options){
		MoveToController.moveTo.move(target, options);
	}

	static registerTrigger(trigger){
		MoveToController.moveTo.registerTrigger(trigger);
	}
}


// WEBPACK FOOTER //
// ./Utils/MoveToController.js